import { findRootChapter } from '../features/ContentRendering/utils/chapterUtils';
import { TOCNode } from '../types';

export interface TargetLocationCandidate {
  chapter?: TOCNode;
  nodeId?: number;
  pageNumber?: string;
}

export interface TargetLocation {
  chapter: TOCNode;
  pageNumber?: string;
}

export function flattenChapters(chapters: TOCNode[]): TOCNode[] {
  return chapters.flatMap((chapter) => [
    chapter,
    ...flattenChapters(chapter.children || []),
  ]);
}

/**
 * Validate the target location to ensure we have at either chapter or page number (or both).
 */
export function isValidTarget(target: TargetLocationCandidate): boolean {
  if (target.chapter || target.pageNumber || target.nodeId) {
    return true;
  }

  return false;
}

export function isChapterLoadRequired(
  currentChapter: TOCNode | null,
  rootChapter: TOCNode,
  chapters: TOCNode[],
): boolean {
  return (
    !currentChapter ||
    rootChapter.nodeId !== findRootChapter(currentChapter, chapters)?.nodeId
  );
}
